import { useEffect, useState } from 'react';
import { relewiseMappingService } from '../MappingService';
import { ProductRecommendationTypes, RelevanceModifier, relewiseRecommendationService } from '../RecommendationService';

const DEFAULT_PRODUCT_COUNT = 6;
const MAX_PRODUCT_COUNT = 20;
export interface ProductRecommendationItem {
    id: string | undefined;
    basePriceFormatted: string;
    finalPriceFormatted: string;
    hasDiscount: boolean;
    displayName: string;
    imgUrl: string;
    productPageUrl: string;
}

interface UseProductRecommendationOptions {
    productCount: number;
    recommendationType: ProductRecommendationTypes;
    isEnabled: boolean;
    displayLocation: string;
    categoryId?: string;
    masterProductItemId?: string;
    relevanceModifier?: RelevanceModifier;
    relevanceModifierStrength?: number;
}

export const useProductRecommendations = ({
    productCount,
    recommendationType,
    isEnabled,
    displayLocation,
    categoryId,
    masterProductItemId,
    relevanceModifier,
    relevanceModifierStrength
}: UseProductRecommendationOptions) => {
    const [products, setProducts] = useState<ProductRecommendationItem[]>([]);
    const [isLoading, setIsLoading] = useState(isEnabled);

    const loadRecommendations = async () => {
        if (!isEnabled) {
            return;
        }
        setIsLoading(true);

        const numberOfProducts = Math.min(productCount ?? DEFAULT_PRODUCT_COUNT, MAX_PRODUCT_COUNT);
        const products = await relewiseRecommendationService.getGenericProductRecommendations({
            recommendationType: recommendationType,
            count: numberOfProducts,
            displayLocation,
            categoryId,
            masterProductItemId,
            relevanceModifier,
            relevanceModifierStrength
        });
        const mappedProducts = relewiseMappingService.mapRelewiseProductResultListToRecommendationItems(products);
        setProducts(mappedProducts);

        setIsLoading(false);
    };

    useEffect(() => {
        loadRecommendations();
    }, [isEnabled]);

    return { products, isLoading };
};
